import React, { useState } from 'react';
import './Email.css';

function Email() {
  const [status, setStatus] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setStatus('');

    try {
      const response = await fetch('https://formspree.io/f/YOUR_FORM_ID', {
        method: 'POST',
        body: new FormData(e.target),
        headers: {
          Accept: 'application/json',
        },
      });

      if (response.ok) {
        setStatus('success');
        e.target.reset();
      } else {
        setStatus('error');
      }
    } catch (error) {
      setStatus('error');
    }

    setIsSubmitting(false);
  };

  return (
    <div className="email-container">
      <header className="email-header">
        <h1 className="email-title">Get in Touch</h1>
        <p className="email-subtitle">
          Feel free to reach out for collaborations, questions, or just to say hello!
          I'll get back to you as soon as possible.
        </p>
      </header>

      {status === 'success' && (
        <div className="form-message success">
          Thank you for your message! I'll get back to you soon.
        </div>
      )}

      {status === 'error' && (
        <div className="form-message error">
          Oops! There was a problem sending your message. Please try again or email me directly at joanna.k.slawinska@gmail.com
        </div>
      )}

      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Name</label>
          <input
            type="text"
            id="name"
            name="name"
            required
            placeholder="Your name"
          />
        </div>

        <div className="form-group">
          <label htmlFor="email">Email</label>
          <input
            type="email"
            id="email"
            name="email"
            required
            placeholder="your.email@example.com"
          />
        </div>

        <div className="form-group">
          <label htmlFor="subject">Subject</label>
          <input
            type="text"
            id="subject"
            name="subject"
            required
            placeholder="What is this regarding?"
          />
        </div>

        <div className="form-group">
          <label htmlFor="message">Message</label>
          <textarea
            id="message"
            name="message"
            required
            placeholder="Your message here..."
          />
        </div>

        <button
          type="submit"
          className="submit-button"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Sending...' : 'Send Message'}
        </button>
      </form>

      <div style={{ marginTop: '2rem', color: '#666', fontSize: '0.9rem' }}>
        <p>You can also reach me directly:</p>
        <p>Email: <a href="mailto:joanna.k.slawinska@gmail.com" style={{ color: '#0074f0' }}>joanna.k.slawinska@gmail.com</a></p>
        <p>Phone: +48 792 906 215</p>
      </div>
    </div>
  );
}

export default Email;